<template>
  <div>
    <vs-row>
      <vs-col>
        <div class="vx-card p-4">
          <div id="user-edit-account-details">
            <div class="vx-row">
              <div class="vx-col w-full">
                <h3>Role details</h3>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-1/2">
                <vs-input class="w-full mt-4" label="Name" v-model="data_local.RoleName" v-validate="'required'"
                          name="RoleName" />
                <span class="text-danger text-sm"  v-show="vErrors.has('RoleName')">{{ vErrors.first('RoleName') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full mt-4" label="Description" v-model="data_local.RoleDescription"
                          v-validate="'required'"
                          name="RoleDescription" />
                <span class="text-danger text-sm"  v-show="vErrors.has('RoleDescription')">{{ vErrors.first('RoleDescription')
                  }}</span>
              </div>
            </div>
            <div class="vx-row mt-4">
              <div class="vx-col w-1/2">
                <label class="vs-input--label">Assigned Application</label>
                <v-select v-model="application_local" :clearable="false" :options="applicationsOptions" v-validate="'required'"
                          name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm"  v-show="vErrors.has('application')">{{ vErrors.first('application') }}</span>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button @click="goBackToView" class="my-4" >Cancel</vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button :disabled="!validateForm"
                    color="light"
                    @click="saveChanges" class="my-4">Save</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      applicationId: null,
      applications: [],
    }
  },
  computed: {
    application_local: {
      get () {
        const app = this.applications.find(({ id }) => id === this.applicationId);

        if (!app) {
          return app;
        }

        return { label: this.capitalize(app.ApplicationName),  value: app.id  }
      },
      set (obj) {
        this.applicationId = obj.value
      }
    },
    application() {
        return this.data.applications.length ? this.data.applications[0] : null;
    },
    validateForm () {
      return !this.vErrors.any()
    },
    applicationsOptions() {
      return this.applications.map(({ id, ApplicationName }) => { return { label: ApplicationName, value: id }  });
    },
    id() {
      return this.data.id;
    }
  },
  created() {
    this.getRelatedData();
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    async saveChanges () {
      /* eslint-disable */
      if (!this.validateForm)  {
        return;
      }

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
      const params = {
        ...this.data_local,
        Application_PK: this.applicationId
      };

      delete params.applications;

      try {
        await this.$api.roles.update(this.id, params);
        this.$vs.notify({
          title: 'Role updated',
          iconPack: 'feather',
          color: 'success',
          position: 'top-right'
        })
        this.goBackToView();
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to update. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    goBackToView () {
        this.$router.push({name: 'role.view', params: { id: this.id }});
    },
    async getRelatedData() {
      if (this.application) {
        this.application_local = {value:this.application.Application_PK}
      }

      await this.getApplications();
    },
    async getApplications() {
      try {
        const { data } = await this.$api.applications.list();
        this.applications = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of applications. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
  }
}
</script>
